import {Injectable} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {AppData} from "./AppData";
import Constants from "../Constants";
import {UrlBuilder} from "../models/frontend_entities/UrlBuilder";
import {WidgetFilterModel} from "../models/dashboard/widget-filter.model";
import {ObjectOverviewModel} from "../models/dashboard/object-overview.model";
import { firstValueFrom, lastValueFrom } from "rxjs";
import {CompoApp} from "./CompoApp";
import { LentBorrowedObjectModel } from '../models/dashboard/lent-borrowed-object.model';
import { DynamicFilterRequestDto } from '../models/dynamic-filter/dynamic-filter-request-dto.model';

@Injectable()
export class WidgetService {

  constructor(private httpClient: HttpClient, private app: CompoApp) {}


  fetchObjectObjectOverView(widgetFilter: WidgetFilterModel) {
    const url = new UrlBuilder(Constants.URLS.widget.objectOverView)
      .param('lang', this.app.data.getLang())
      .build();
    return lastValueFrom(this.httpClient.post<ObjectOverviewModel[]>(url, widgetFilter));
  }

  fetchLentOrBorrowedObjects(widgetFilter: DynamicFilterRequestDto) {
    const url = new UrlBuilder(Constants.URLS.widget.lentOrBorrowedObjects)
    .param('lang', this.app.data.getLang())
    .build();
    return firstValueFrom(this.httpClient.post<LentBorrowedObjectModel[]>(url, widgetFilter));
  }
}
